export default __webpack_public_path__ + "static/media/ug.db68bb1b.svg";